import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { takeUntil } from 'rxjs';

import { OrientationEnum, ThemesEnum } from '@seb/web-design-system/core';

import { BaseCrossSellComponent } from '../../../components/base/base-cross-sell/base-cross-sell.component';
import { CrossSellCodeInterface, CrossSellComponentInterface } from '../../../models';
import { AbstractComponent } from '../abstract-component.component';
import { WrapperComponent } from '../../../components/static/core';
import { UppercaseThemesEnum } from '../../../enums';

@Component({
  selector: 'wc-cross-sell',
  templateUrl: './cross-sell.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    WrapperComponent,
    BaseCrossSellComponent
  ]
})
export class CrossSellComponent extends AbstractComponent<CrossSellComponentInterface> implements OnInit {
  codes: CrossSellCodeInterface;
  layout: OrientationEnum;
  showMoreDesktop: boolean;
  isEmbedded: boolean;

  readonly context = 'Homepage';

  constructor(private cdRef: ChangeDetectorRef) {
    super();
  }

  override mandatoryFunction = (cmp: CrossSellComponentInterface): boolean => {
    return (!!cmp.products && cmp.products.length > 0) || (!!cmp.bundles && cmp.bundles.length > 0);
  };

  ngOnInit(): void {
    this.component$.pipe(takeUntil(this.destroy$)).subscribe((data: CrossSellComponentInterface) => {
      this.isEmbedded =
        ((!!this.wrapper?.wrapperBackgroundTheme || !!this.wrapper?.wrapperBackgroundImage?.code) &&
          this.wrapper?.wrapperBackgroundTheme !== ThemesEnum.default &&
          this.wrapper?.wrapperBackgroundTheme !== UppercaseThemesEnum.DEFAULT) ||
        (this.wrapper?.wrapperBackgroundImage && this.wrapper?.wrapperBackgroundTheme === UppercaseThemesEnum.DEFAULT);
      this.codes = {
        products: data.products?.split(' '),
        bundles: data.bundles?.split(' ')
      };
      this.layout = this.wrapper?.layouts?.toLowerCase() as OrientationEnum;
      this.showMoreDesktop = this.layout === OrientationEnum.column;
      this.setLoaded();
      this.cdRef.markForCheck();
    });
  }
}
